import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  inputWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    alignItems: 'center',
  },
  applyButton: {
    height: '40px',
  },
  input: {
    minWidth: '351px',
  },
  tcv: {
    background: theme.palette.bgV2.light,
    padding: `${theme.spacing(3)}px !important`,
    borderRadius: '4px',
  },
  currency: {
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    fontSize: '14px',
  },
  price: {
    display: 'flex',
    alignItems: 'baseline',
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: '-8px',
  },
  disabledApply: {
    marginBottom: theme.spacing(2),
  },
  markupWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  description: {
    marginBottom: theme.spacing(-1.75),
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  errorMessage: {
    color: theme.palette.error.dark,
    fontSize: '12px',
    marginTop: theme.spacing(0.5),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
}))
